module.exports = __webpack_public_path__ + "img/thumb-mech.9b0cc0a6.png";